import { useSignInHandlers } from "scripts/hooks/useSignInHandlers";
import { useQueryFlags } from "scripts/hooks/useQueryFlags";
import { IUser } from "services/UserContext";
import { IAssistant } from "layouts/DefaultLayout";

interface SidebarSignUpProps {
  user: IUser;
  assistant: IAssistant | undefined;
}

/**
 * Sidebar sign-up/sign-in prompt — extracted from DefaultLayout so that
 * `useSignInHandlers` is called **inside** the ShareContext.Provider tree
 * and can properly read `listingDetailShareUrlRef` from context.
 */
export const SidebarSignUp = ({ user, assistant }: SidebarSignUpProps) => {
  const { handleSignIn, handleCreateAccount } = useSignInHandlers(user?.user_id);
  const { embed } = useQueryFlags();

  if (user.loading) return null;
  if (assistant && user.user_id && user.role_id) return null;

  return (
    <div className="d-flex flex-column flex-grow-1">
      {(!user.user_id || !user.role_id) && (
        <div
          className="mt-auto mx-4 mb-4 border_radius--pudgy bg_color_snow_white p-4 depth--above_all"
          id="userSignup"
        >
          <div className="font_size--large text-center font_weight--bold_extra color_carbon pb-0">
            Sign in or
            <br />
            create an account
          </div>
          <div className="font_size--small_extra text-center mb-4">
            Unlock all features and history
          </div>

          <button
            type="button"
            className="btn btn--primary btn--large w-100 mb-3"
            {...(embed
              ? { onClick: handleSignIn }
              : { "data-toggle": "modal", "data-target": "#registerLogin" })}
          >
            Sign In
          </button>

          <div className="text-center border-bottom border-color--cloudy-sky pb-3 mb-3">
            <a
              href="https://www.har.com/login/forgotpassword"
              target="_blank"
              rel="noopener noreferrer"
            >
              Forgot your password?
            </a>{" "}
            <a
              className="h2--simple__black"
              href="https://www.har.com/contact-us"
            >
              Contact Us
            </a>
          </div>
          <div className="text-center">
            or{" "}
            <a
              href="#"
              className="font_weight--semi_bold"
              onClick={handleCreateAccount}
            >
              Sign up / Create an account
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
